import { Poker2Constants } from "../../../constants/Poker2Constants";
import { Poker2ShopEvent } from "../../../event/Poker2ShopEvent";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2StarterPackageBoughtDialogProperties } from "./Poker2StarterPackageBoughtDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2StarterPackageBoughtDialog extends Poker2Dialog {
    public static NAME: string = "Poker2StarterPackageBoughtDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();

        this.dialogTemplate.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    protected applyProperties(): void {
        this.dialogTemplate.txt_title.text = Poker2Model.languageData.getTextById("dialog_bundles_title");
        this.dialogTemplate.txt_copy.text = Poker2Model.languageData.getTextById("dialog_bundles_text");

        // btn back
        this.dialogTemplate.btn_back.label = Poker2Model.languageData.getTextById("generic_btn_goback");

        var label: string;
        var option: number = 0;
        if (Poker2Model.itemShop.starterPackageBoughtId == 1 || Poker2Model.itemShop.starterPackageBoughtId == 3) {
            // to inventory
            label = Poker2Model.languageData.getTextById("dialog_bundles_button1");
            option = 0;
        }
        else if (Poker2Model.itemShop.starterPackageBoughtId == 2 || Poker2Model.itemShop.starterPackageBoughtId == 4) {
            // to boosters
            label = Poker2Model.languageData.getTextById("dialog_bundles_button2");
            option = 1;
        }

        this.dialogTemplate.btn_deeplink.label = label;
        this.dialogTemplate.btn_deeplink.option = option;
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.dialogTemplate.btn_back:
            case this.dialogTemplate.btn_close:

                this.hide();
                break;

            case this.dialogTemplate.btn_deeplink:

                console.log("BTN DEEPLINK -> option: " + this.dialogTemplate.btn_deeplink.option);

                if (this.dialogTemplate.btn_deeplink.option == 0) {
                    // jump to inventory
                    Poker2LayoutManager.getInstance().state = 13;

                    // update view to show inventory
                    this.controller.dispatchEvent(new Poker2UserEvent("changeShopState", ["stateInventory"]));

                    // jump to the extras category within the inventory
                    this.controller.dispatchEvent(new Poker2ShopEvent("changeCategory", ["extras"]));

                    // jump to the pets subcategory within the inventory
                    this.controller.dispatchEvent(new Poker2ShopEvent("changeSubCategory", ["shopPet"]));
                }
                else if (this.dialogTemplate.btn_deeplink.option == 1) {
                    // jump to boosters
                    Poker2LayoutManager.getInstance().state = 20;
                }

                this.hide();
                break;
        }
    }

    private get dialogProperties(): Poker2StarterPackageBoughtDialogProperties {
        return this.properties as Poker2StarterPackageBoughtDialogProperties;
    }

    private get dialogTemplate(): Library.PokerInterface.PokerStarterPackageBought {
        return this.disp as Library.PokerInterface.PokerStarterPackageBought;
    }
}
import { Poker2LayoutManager } from "../../Poker2LayoutManager";
import { Poker2ShopScreen } from "../../screens/Poker2ShopScreen";
